import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';

const StickyCallButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <a
      href="tel:+611300404229"
      className={`fixed bottom-6 right-6 z-50 w-16 h-16 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
      style={{ backgroundColor: '#81b956' }}
      aria-label="Call us now"
    >
      <Phone className="w-7 h-7 text-white animate-pulse" />
      
      {/* Ripple effect */}
      <span 
        className="absolute inset-0 rounded-full animate-ping opacity-75"
        style={{ backgroundColor: '#81b956' }}
      />
    </a>
  );
};

export default StickyCallButton;
